module.exports = __webpack_public_path__ + "static/media/amazon-alexa@2x.52599093.jpg";